import React from 'react';
import { motion } from 'framer-motion';
import { useScreenInit } from '../useScreenInit.js';
import { Truck, RotateCcw, ShieldCheck, Info } from 'lucide-react';
export function Policies() {
  useScreenInit();
  return <div className="min-h-screen bg-white pt-32 pb-20" data-id="element-843">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-844">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-16" data-id="element-845">
          <h1 className="text-4xl md:text-6xl font-serif mb-6" data-id="element-846">
            Store Policies
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-847"></div>
        </motion.div>

        <div className="space-y-16" data-id="element-848">
          {/* Refund Policy */}
          <section data-id="element-849">
            <div className="flex items-center gap-4 mb-8" data-id="element-850">
              <div className="p-3 bg-gray-50 rounded-full text-gold" data-id="element-851">
                <RotateCcw size={24} data-id="element-852" />
              </div>
              <h2 className="text-2xl md:text-3xl font-serif" data-id="element-853">Refund Policy</h2>
            </div>
            <div className="bg-gray-50 p-8 border-l-4 border-gold" data-id="element-854">
              <h3 className="text-lg font-bold uppercase tracking-widest mb-4" data-id="element-855">
                No Refunds
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6" data-id="element-856">
                We maintain a strict NO REFUNDS policy. However, we want you to
                be completely satisfied with your TriLyn purchase.
              </p>
              <div className="space-y-4" data-id="element-857">
                <div className="flex items-start gap-3" data-id="element-858">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 flex-shrink-0" data-id="element-859" />
                  <p className="text-gray-600" data-id="element-860">
                    Returns will be accepted at the customer's expense as long
                    as the item is in its original, unused condition with all
                    tags attached.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-861">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 flex-shrink-0" data-id="element-862" />
                  <p className="text-gray-600" data-id="element-863">
                    Customers can exchange returned items for an item of equal
                    or lesser value.
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-864">
                  <div className="w-1.5 h-1.5 bg-gold rounded-full mt-2 flex-shrink-0" data-id="element-865" />
                  <p className="text-gray-600" data-id="element-866">
                    Exchanges are limited to one time per item being exchanged.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Shipping Policy */}
          <section data-id="element-867">
            <div className="flex items-center gap-4 mb-8" data-id="element-868">
              <div className="p-3 bg-gray-50 rounded-full text-gold" data-id="element-869">
                <Truck size={24} data-id="element-870" />
              </div>
              <h2 className="text-2xl md:text-3xl font-serif" data-id="element-871">
                Shipping Policy
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-872">
              <div className="bg-white p-8 border border-gray-100 shadow-sm" data-id="element-873">
                <h3 className="text-lg font-bold uppercase tracking-widest mb-4 text-gold" data-id="element-874">
                  Domestic Shipping
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-875">
                  We offer shipping throughout the United States for an
                  additional cost. Delivery costs will vary based on your
                  location outside of Baltimore City, Maryland.
                </p>
              </div>
              <div className="bg-black text-white p-8 shadow-xl" data-id="element-876">
                <h3 className="text-lg font-bold uppercase tracking-widest mb-4 text-gold" data-id="element-877">
                  Baltimore Local
                </h3>
                <p className="text-gray-300 leading-relaxed" data-id="element-878">
                  We are proud to offer FREE delivery within the Baltimore City
                  area. This service is provided free of charge for our local
                  community.
                </p>
              </div>
            </div>
          </section>

          {/* Security & Trust */}
          <section className="pt-8 border-t border-gray-100" data-id="element-879">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-880">
              <div className="space-y-3" data-id="element-881">
                <ShieldCheck size={32} className="mx-auto text-gold" data-id="element-882" />
                <h4 className="font-bold uppercase tracking-widest text-xs" data-id="element-883">
                  Secure Payment
                </h4>
                <p className="text-xs text-gray-400" data-id="element-884">
                  Your data is protected by industry-standard encryption.
                </p>
              </div>
              <div className="space-y-3" data-id="element-885">
                <Info size={32} className="mx-auto text-gold" data-id="element-886" />
                <h4 className="font-bold uppercase tracking-widest text-xs" data-id="element-887">
                  Authenticity
                </h4>
                <p className="text-xs text-gray-400" data-id="element-888">
                  Every piece is personally vetted for cultural significance.
                </p>
              </div>
              <div className="space-y-3" data-id="element-889">
                <Truck size={32} className="mx-auto text-gold" data-id="element-890" />
                <h4 className="font-bold uppercase tracking-widest text-xs" data-id="element-891">
                  Reliable Delivery
                </h4>
                <p className="text-xs text-gray-400" data-id="element-892">
                  Tracked shipping on all domestic orders.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>;
}